/**
 * LATAM-SCRIPTS
 * ============
 *
 * This is the main Javascript bundle for the LATAM website.
 */

//1. index.js is from Vshift -- do not modify this path.
require("./sources/index.js");

//2. Overrides from VanEck
require('./override/index.js');

require('../../../eu/js/src/funds/performance-past-years-chart');